import {Component} from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent {
  public disabled: boolean = false;
  public status: { isOpen: boolean } = {isOpen: false};

  public toggled(open: boolean): void {
    console.log('Dropdown is now: ', open);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isOpen = !this.status.isOpen;
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/layouts/full-layout.component.ts